import { Components, Theme } from '@mui/material'

export const MuiDialogActions: Components<Omit<Theme, 'components'>>['MuiDialogActions'] = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: 24,
      paddingRight: 24,
      paddingTop: 16,
      paddingBottom: 16,
      borderTop: '1px solid',
      borderColor: theme.palette.neutralLight[300],
    }),
  },
}
